
import { CardHeader } from 'reactstrap'
import { H2, P } from '../../../../AbstractElements'

export default function TrailRequestCardHeader({ headClass, title, subTitle, titleClass }: any) {
    return (
        <CardHeader className={headClass}>
            <H2 className={`mb-0 ${titleClass ? titleClass : ''}`}>{title}</H2>
            {subTitle && (
                <P className="f-m-light mt-2">
                    {subTitle}
                </P>
            )}
        </CardHeader>
    )
}